
import { Component, Vue } from 'vue-property-decorator'
import { ProjectService } from "@/services/timetrack/ProjectService"
import { CollaboratorService } from "@/services/timetrack/CollaboratorService"
import { CollaborationState } from "@/types/collaborator/Collaborator"
import SnackbarMessage from "@/components/SnackbarMessage.vue"

@Component({
  filters: {
  },
  components: {
    SnackbarMessage
  }
})
export default class CollaborationDisabledHandler extends Vue {
  private showMessage = false
  private message: string | null = null
  private color: string | null = null
  private projectService = new ProjectService()
  private collaborationService = new CollaboratorService()

  created () {
    this.disableProjectsFromCollaboration()
    this.reactivateProjectsFromCollaboration()
  }

  private disableProjectsFromCollaboration () {
    this.collaborationService.getProjectForCustomerByState(CollaborationState.disable)
      .then((collaborations) => {
        collaborations.forEach((collab) => {
          if (!collab || !collab.collaboratorProjectId) return
          this.projectService.setProjectState(collab.collaboratorProjectId, false)
            .then(() => {
              if (!collab || !collab.id) return
              this.collaborationService.setCollaboratorState(collab.id, CollaborationState.disabled)
                .then(() => {
                  if (!collab || !collab.collaboratorProjectId) return
                  this.projectService.getProject(collab.collaboratorProjectId)
                    .then((project) => {
                      if (!project || !project.name) return
                      this.message = this.$t('timetrack.collab.deactivation', { name: project.name }) as string
                      this.showMessage = true
                      this.color = 'red'
                    })
                })
            })
        })
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      })
  }

  private reactivateProjectsFromCollaboration () {
    this.collaborationService.getProjectForCustomerByState(CollaborationState.reactivated)
      .then((collaborations) => {
        collaborations.forEach((collab) => {
          if (!collab || !collab.collaboratorProjectId || !collab.id) return
          this.projectService.setProjectState(collab.collaboratorProjectId, true)
            .then(() => {
              if (!collab || !collab.id) return
              this.collaborationService.setCollaboratorState(collab.id, CollaborationState.active)
                .then(() => {
                  if (!collab || !collab.collaboratorProjectId) return
                  this.projectService.getProject(collab.collaboratorProjectId)
                    .then((project) => {
                      if (!project || !project.name) return
                      this.message = this.$t('timetrack.collab.reactivation', { name: project.name }) as string
                      this.showMessage = true
                      this.color = 'success'
                      this.$emit('projectCreated')
                    })
                })
            })
        })
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      })
  }
}
